<script>
    import { get_badges } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_badges.js?1733898724612';

    export let product;

    $: badges = get_badges(product);
</script>

{#if badges && get_badges.length > 0}
    <div class="m-product-list__badges">
        {#each badges as badge}
            <span class="{badge.class}">{badge.name}</span>
        {/each}
    </div>
{/if}


<style>
    .m-product-list__badges {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    :global(.m-product-badge__sale) {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 60px;
        height: 60px;
        background: var(--red);
        color: var(--white);
        font-size: 18px;
        font-weight: var(--font-weight__extrabold);
        text-transform: var(--font-heading-text-transform);
        margin-bottom: 3px;
    }

    :global(.m-product-badge__bestseller),
    :global(.m-product-badge__sustainable),
    :global(.m-product-badge__vegan) {
        font-size: var(--h6__font-size);
        font-weight: var(--h6__font-weight);
        line-height: var(--h6__line-height);
        color: var(--h6__color);
        margin: var(--h6__margin);
        text-transform: none;
        font-weight: var(--font-weight__semibold);
        line-height: 1;
        text-transform: uppercase;
        color: var(--lightbrown);
        background: var(--darkblue);
        padding: 5px;
        margin-bottom: 3px;
    }

    @media (min-width: 992px) {
        :global(.m-product-badge__bestseller),
        :global(.m-product-badge__sustainable),
        :global(.m-product-badge__vegan) {
            font-size: var(--h6__font-size-desktop);
        }
    }

    :global(.m-product-badge__sustainable) {
        background: var(--green);
    }
</style>